import { ListRecipesQueryVariables } from "@akin-home/amplify";
import {
  listAllRecipesQuery,
  recipeGraphqlToModel,
} from '@akin-home/recipes-front-end';
import { useMemo } from "react";
import { useQuery } from "react-query";
import { recipesQueryKey } from './query_key';

/** Returns all recipes in a single list */
export const useListAllRecipes = ({
  params,
  options,
}: {
  params?: ListRecipesQueryVariables;
  options?: any;
}) =>
  useQuery(
    recipesQueryKey.list(params),
    () => listAllRecipesQuery(params),
    options
  );

export const useListAllRecipeModels = (params: {
  params: ListRecipesQueryVariables;
  options?: any;
}) => {
  const { data, ...result } = useListAllRecipes(params);

  const recipes = useMemo(
    () => data?.map((d) => recipeGraphqlToModel(d)) || [],
    [data]
  );

  return {
    ...result,
    recipes,
  };
};
